import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Button, Link } from '@mui/material';
import React from 'react'
import colors from '../colors'
import { texts } from './texts';
import { useSelector } from 'react-redux';
import { selectUtilityState } from '../../features/utilities/utilitySlice';

export const ConfirmationDialog = (props) => {

  const isOpen = props.isConfirmationDialogOpen
  const utilitySliceState = useSelector(selectUtilityState) 

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (isOpen) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [isOpen]);

  return (
    <Grid>
      <Dialog
        open={isOpen}
        onClose={props.handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        PaperProps={{
            style: {
              borderRadius:'20px'
            },
          }}
      >
        <DialogTitle id="scroll-dialog-title" sx={{textAlign:'center', background:colors.gradientOrange, color:colors.white, fontSize:'1.3rem', fontFamily:'GerberaBold'}} >{texts["button-confirm"]}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            pt={'8%'}
            sx={{fontSize:'1rem', color:colors.darkBlue, textAlign:'center', fontFamily:"GerberaLight"}}
          >
            {props.data}
          </DialogContentText>
        </DialogContent>
          <Grid container direction={'column'} pb={'3%'} >
            <Grid container item md={12} justifyContent={'center'} pb={'1.5%'} pt={'3%'}>
                <Button disabled={utilitySliceState.isLoading ? true : false} onClick={props.handleConfirmationClick}  sx={{color:colors.white, background:colors.gradientOrange, fontFamily:'GerberaBold', textTransform:'none'}} >{texts["button-confirm"]}</Button>
            </Grid>
            <Grid container item md={12} justifyContent={'center'} >
                <Link disabled={utilitySliceState.isLoading ? true : false} component='button' onClick={props.handleClose}  sx={{color:colors.darkBlue, fontFamily:'GerberaLight'}} >{texts["button-cancel"]}</Link>
            </Grid>
          </Grid>
      </Dialog>
    </Grid>
  )
}
export default ConfirmationDialog